export default "__VITE_ASSET__Bv6$kt4B__"